module.exports = "/assets/data/7a4dcfea1a043f336c6ef03374e55332-RG12.data.json";